import type { QueryClient } from "@tanstack/react-query";
import { projectCommentsKeys } from "queries/projectComments.keys";
import {
  DEFAULT_PROJECT_COMMENTS_SHELL_STATE,
  type ProjectCommentsShellState,
} from "./projectComments.types";

export function getProjectCommentsShellState(
  queryClient: QueryClient,
  projectId: string,
  documentId: string
): ProjectCommentsShellState {
  return (
    queryClient.getQueryData<ProjectCommentsShellState>(
      projectCommentsKeys.shell(projectId, documentId)
    ) ?? DEFAULT_PROJECT_COMMENTS_SHELL_STATE
  );
}

export function patchProjectCommentsShellState(
  queryClient: QueryClient,
  projectId: string,
  documentId: string,
  patch:
    | Partial<ProjectCommentsShellState>
    | ((prev: ProjectCommentsShellState) => ProjectCommentsShellState)
): void {
  const queryKey = projectCommentsKeys.shell(projectId, documentId);
  queryClient.setQueryData<ProjectCommentsShellState>(queryKey, (prev) => {
    const current = prev ?? DEFAULT_PROJECT_COMMENTS_SHELL_STATE;
    return typeof patch === "function" ? patch(current) : { ...current, ...patch };
  });
}

export function resetProjectCommentsShellState(
  queryClient: QueryClient,
  projectId: string,
  documentId: string
): void {
  patchProjectCommentsShellState(
    queryClient,
    projectId,
    documentId,
    DEFAULT_PROJECT_COMMENTS_SHELL_STATE
  );
}
